'use client'

import { useMemo } from 'react'
import { useNotebook } from '@/lib/notebook/core/store'
import { SectionExplorer } from '@/lib/notebook/Blocks/explorer/SectionExplorer'
import { LAUNCHER_ENTRIES } from '@/lib/notebook/registry/sections-registry'
import { isStructuralSectionType } from '@/lib/notebook/layout/notebook-layout'

export default function SectionLauncher({ onClose }) {
  const addSection = useNotebook((s) => s.addSection)
  const launcherTarget = useNotebook((s) => s.launcherTarget)

  const entries = useMemo(
    () =>
      LAUNCHER_ENTRIES.filter((entry) => {
        if (launcherTarget?.kind === 'tab') {
          return entry.type !== 'block_tabs'
        }
        return !isStructuralSectionType(entry.type)
      }),
    [launcherTarget],
  )

  return (
    <SectionExplorer
      entries={entries}
      onClose={onClose}
      onAdd={(type) => {
        addSection(type)
        onClose()
      }}
    />
  )
}
